export default __webpack_public_path__ + "static/media/employer_ico_1.12eb60b1.svg";